<template>
  <a-drawer width="45%" :label-col="8" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('会员等级名称')" prop="levelName">
        <a-input v-model="form.levelName" :placeholder="$t('请输入')+$t('会员等级名称')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['levelName']"
            :disabled="!form.levelName"
            input-type="input"
            table-name="user_user_level"
            table-field="levelName"
            :field-value="form.levelName"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('消费金额(美元)')" prop="upgradeScore">
        <div style="display: flex; align-items: center; width: 100%;">
          <a-form-model-item prop="upgradeScore" style="flex: 1; margin-bottom: 0;">
            <a-input-number v-model="form.upgradeScore" style="width:95%;" :placeholder="$t('请输入')+$t('此等级消费最低金额')" :min="0"  />
          </a-form-model-item>
          <span style="padding: 0 10px; white-space: nowrap;">{{$t('至')}}</span>
          <a-form-model-item prop="upgradeScoreMax" style="flex: 1; margin-bottom: 0;">
            <a-input-number v-model="form.upgradeScoreMax" style="width: 95%;" :placeholder="$t('请输入')+$t('此等级消费最大金额')" :min="0" />
          </a-form-model-item>
        </div>

      </a-form-model-item>
      <a-form-model-item :label="$t('赠送优惠券张数')" prop="couponTimes">
        <a-input-number v-model="form.couponTimes" :placeholder="$t('请输入')+$t('赠送优惠券张数')" :min="0" />
      </a-form-model-item>
      <a-form-model-item :label="$t('专属折扣比例')" prop="discount">
        <a-input-number v-model="form.discount * 100" :placeholder="$t('请输入')+$t('专属折扣比例')" :min="1" :max="100" />%
      </a-form-model-item>
      <a-form-model-item :label="this.$t('等级图片')" prop="icon">
        <oss-upload-single :height="100" :width="100"  v-model="form.icon" prefix="icon" type="img"/>
        <span>{{$t('推荐尺寸')}} 255 x 255</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" prop="upgradeScore">
        <a-switch v-model="form.status"></a-switch>
      </a-form-model-item>
      <a-form-model-item :label="$t('权益介绍')" prop="remark">
        <a-input v-model="form.remark" type="textarea" :rows="10" :placeholder="$t('请输入')+$t('权益介绍')" />
        <locale-field-button
          class="ant-input-suffix-button"
          v-model="form.localeFieldMap['remark']"
          :disabled="!form.remark"
          input-type="textarea"
          table-name="user_user_level"
          table-field="remark"
          :field-value="form.remark"
        />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLevel, addLevel, updateLevel } from '@/api/user/level'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject, uploadOss } from '@/api/tool/oss'
import Editor from '@/components/Editor'
import { translation } from '@/api/tool/common'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    CustomDictTag,
    Editor
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage: undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('会员等级名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 表单参数
      form: {
        id: null,
        localeList: [],
        levelName: null,

        sort: null,
        picture: null,
        upgradeScore: null,
        upgradeScoreMax: null,
        discount: 100,
        lotteryTimes: null,
        freightFree: null,
        birthdayGift: null,
        birthdayGiftContent: null,
        upgradeGift: null,
        upgradeGiftContent: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
        couponTimes: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        levelName: [
          { required: true, message: this.$t('会员等级名称') + this.$t('不能为空'), trigger: 'blur' }
        ],
        upgradeScore: [
          { required: true, message: this.$t('此等级所需消费最小金额') + this.$t('不能为空'), trigger: 'blur' }
        ],
        upgradeScoreMax: [
          { required: true, message: this.$t('此等级所需消费最大金额') + this.$t('不能为空'), trigger: 'blur' }
        ],
        discount: [
          { required: true, message: this.$t('折扣') + this.$t('不能为空'), trigger: 'blur' }
        ],
        couponTimes: [
          { required: true, message: this.$t('赠送的消费券数量') + this.$t('不能为空'), trigger: 'blur' }
        ]

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        localeList: [],
        levelName: null,
        sort: null,
        picture: null,
        upgradeScore: null,
        discount: 100,
        lotteryTimes: null,
        freightFree: null,
        birthdayGift: null,
        birthdayGiftContent: null,
        upgradeGift: null,
        upgradeGiftContent: null,
        createTime: null,
        localeFieldMap:{},
        remark: null
      }

    },
    /*text 要翻译的字段*/
    getTranslation(record) {
      if (!this.form.levelName) {
        return
      }
      let data = { 'text': this.form.levelName, 'locale': record.locale }
      translation(data).then(response => {
        record.name = response.data
      })
    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },
    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error(this.$t('上传图片大小不能超过 20MB!'))
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'user'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('上传成功'))
        })
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.initLocale()
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLevel({ 'id': id }).then(response => {
        this.form = response.data
        if(response.data.status == 1){
          this.form.status = true;
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            if(this.form.status){
              this.form.status = 1
            }else{
              this.form.status = 0
            }
            if(this.form.discount != null){
              this.form.discount = this.form.discount/100
            }
            updateLevel(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLevel(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
